import Vue from 'vue'
import * as routing from '@/util/routes'
const { usuario: usuarioRoute } = routing

export default {
  state: {
    usuario: {},
    usuarios: [],
    regras: [],
    paginateUsuarios: {
      data: []
    },
    usuarioPage: 1,
    usuarioFilter: ''
  },
  mutations: {
    setUsuario: (state, payload) => {
      state.usuario = payload
    },
    setUsuarios: (state, payload) => {
      state.usuarios = payload
    },
    setPaginateUsuarios: (state, payload) => {
      state.paginateUsuarios = payload
    },
    setRegrasUsuarios: (state, payload = 1) => {
      state.regras = payload
    },
    setUsuarioPage: (state, payload = 1) => {
      state.usuarioPage = payload
    },
    setUsuarioFilter: (state, payload = '') => {
      state.usuarioFilter = payload
    }
  },
  actions: {
    async getPaginateUsuarios ({ commit, state }, payload) {
      commit('setPaginateUsuarios', {
        data: []
      })
      const { data } = await Vue.axios.get(`${usuarioRoute}`, {
        headers: {
          page: state.usuarioPage,
          filter: state.usuarioFilter
        }
      })
      commit('setPaginateUsuarios', data)
    },
    async getUsuarios ({ commit }, payload) {
      commit('setUsuarios', [])
      const { data } = await Vue.axios.get(`${usuarioRoute}`, {
        headers: {
          limit: 0,
          ...payload
        }
      })
      commit('setUsuarios', data)
    },
    async getUsuario ({ commit }, { id }) {
      const { data } = await Vue.axios.get(`${usuarioRoute}/${id}`)
      commit('setUsuario', data)
    },
    async getLogged ({ commit }) {
      const { data } = await Vue.axios.get(`${routing.default}/logged`)
      commit('setUsuario', data)
    },
    async getRegrasUsuarios ({ commit }) {
      const { data } = await Vue.axios.get(`${usuarioRoute}/regras`)
      commit('setRegrasUsuarios', data)
    },
    async postSaveUsuario ({ state }) {
      const { usuario } = state
      if (usuario.id) {
        const user = await Vue.axios.put(`${usuarioRoute}/${usuario.id}`, usuario)
        return user
      }
      return Vue.axios.post(`${usuarioRoute}`, usuario)
    },
    async postSaveLogged ({ state }) {
      const { usuario } = state
      return Vue.axios.put(`${routing.default}/logged`, usuario)
    },
    async putUpdateRegraUsuario ({ state }, { role }) {
      const { usuario } = state
      return Vue.axios.put(`${usuarioRoute}/${usuario.id}/regras`, { role })
    },
    async deleteUsuario ({ state }) {
      const { usuario } = state
      return Vue.axios.delete(`${usuarioRoute}/${usuario.id}`)
    }
  },
  getters: {
    usuario: ({ usuario }) => usuario,
    usuarioPage: ({ usuarioPage }) => usuarioPage,
    usuarioFilter: ({ usuarioFilter }) => usuarioFilter,
    regras: ({ regras }) => regras,
    usuarios: ({ usuarios }) => usuarios,
    paginateUsuarios: ({ paginateUsuarios }) => paginateUsuarios
  }
}
